import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import YearViewComp from "./YearViewComp";
import styles from "./css/CalendarComp.module.css";
import { FlexboxGrid } from 'rsuite';
import FlexboxGridItem from 'rsuite/lib/FlexboxGrid/FlexboxGridItem';
import { RootState } from 'services/rootReducer';
import SortControl from "components/SortControl";
import DateNav from "components/DateNav";
import ViewSwitch from "components/ViewSwitch";
import LatestEntryInfo from "components/LatestEntryInfo";
import { format, parseISO } from 'date-fns';
import MonthViewComp from './MonthViewComp';
import CONSTANTS from "../../constants"
import WeekViewComp from './WeekViewComp';
import { getHeatMap, selectCalendarRange, selectViewType, selectAutoNav } from 'services/View_Slice';
//import { buildQueryViewParamsCal } from 'components/utils/queryHelper';
//import { doQuery } from 'services/Query_Slice';

import styled from "styled-components";
import InlineSpinner from 'components/InlineSpinner';
const dimStyle: React.CSSProperties = { opacity: 0.5, pointerEvents: 'none' };

export type CalendarProps2 = {
  startDate: Date;
  endDate: Date;
};

type CalendarProps = {
    startDate: Date;
    endDate: Date;
    events: Array<any>;
    mobile: boolean,
    width: number
};

const StyledDiv = styled.div`
    background-color: ${props => props.color};
`;

const CalendarComp: React.FC<CalendarProps> = (props) => {
    const viewType = useSelector(selectViewType);
    const { calRangeUsed, calRangeValue } = useSelector(selectCalendarRange);
    const isAutoNavigating = useSelector(selectAutoNav);
    const urlConstraintsUsed = useSelector((state: RootState) => state.View.urlConstraintsUsed);
    const mobile = useSelector((state: RootState) => state.View.mobile);
    const facetSelected = useSelector((state: RootState) => state.Facets.facetSelected)
    const loading = useSelector((state: RootState) => state.Loading.loading)
    const [dataReady, setDataReady] = useState(true);
    const latestDateInfo = useSelector((state: RootState) => state.FacetNavigation.latestDateInfo)
    //const {request} = useSelector((state: RootState) => state.Query)
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch)
    // const operator = 'Or'; /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */
    const usedTitleLabel = mobile? styles.title_mobile: styles.title;

    // Conditional class for centering control bar when filters are active
    const controlBarClass = latestDateInfo
        ? `${styles.controlBar} ${styles.hasActiveFilters}`
        : styles.controlBar;

    // calculate end of the week
    const calcLastWeekDay = (value : number, month: string) =>{
        var date = parseISO(calRangeValue)
        var endDate = new Date(date.setDate(date.getDate() + 6))
        var anEndDateStr = format(endDate, "yyyy-MM-dd")
        return anEndDateStr;
    }

    const endDateStr = calcLastWeekDay(parseInt(calRangeValue.split("-")[2]), calRangeValue.split("-")[1])

    const dispatch = useDispatch()
    var start: string = '';
    var end: string = '';
    var dateEnd;
    switch(calRangeUsed){
        case 0: 
        start = calRangeValue+'-01T00:00:00Z'; 
        dateEnd = new Date(parseInt(calRangeValue.split('-')[0]), parseInt(calRangeValue.split('-')[1]), 0);
        end = format(dateEnd,'yyyy-MM-dd') +'T23:59:59Z'
        break;
        case 1: 
        start = calRangeValue+'T00:00:00Z';
        dateEnd = parseISO(calRangeValue)
        dateEnd = dateEnd.setDate(dateEnd.getDate() + 7)
        end = format(dateEnd,'yyyy-MM-dd') +'T23:59:59Z'
        break;  
        case 3:
        start = calRangeValue+'-01-01T00:00:00Z'; 
        end = calRangeValue+'-12-31T23:59:59Z'
        break;    
    }

    useEffect(() => {
        // Skip heatmap during auto-navigation - a second call will follow immediately
        // when the navigation completes with the final date values
        if (isAutoNavigating) return;
        // Wait until the URL parameters are applied, otherwise a deep link first requests the
        // default (current) period and that answer can overwrite the linked period's heatmap
        if (!urlConstraintsUsed) return;
        setDataReady(false);
        dispatch(getHeatMap(start, end, facetSelected, freeTextSearch, CONSTANTS.DEFAULT_OPERATOR_TO_USE)) /* === AND/OR OPERATOR FEATURE - USING DEFAULT CONSTANT === */
    }, [dispatch, start, end, facetSelected, freeTextSearch, isAutoNavigating, urlConstraintsUsed])

    // Defer spinner removal: useLayoutEffect fires after ALL child components
    // (YearViewComp, MonthViewComp) have rendered their heatmap colors into the DOM,
    // but BEFORE the browser paints. This ensures no colorless flash.
    useLayoutEffect(() => {
        if (!loading && !dataReady) {
            setDataReady(true);
        }
    }, [loading, dataReady]);

    //render calendarComp
    return (
        <div className='calendar-container' style={{position: 'relative'}}>
                {!mobile ?
                <FlexboxGrid justify="space-between" className={controlBarClass}>
                    <FlexboxGridItem className={styles.latestEntryItem}>
                        <LatestEntryInfo />
                    </FlexboxGridItem>

                    <FlexboxGridItem>
                        <FlexboxGrid justify="end" className={styles.controlsRow}>
                            <FlexboxGridItem>
                                <ViewSwitch/>
                            </FlexboxGridItem>

                            <FlexboxGridItem>
                                <DateNav width={props.width} mobile={props.mobile}/>
                            </FlexboxGridItem>

                            <FlexboxGridItem>
                                { viewType===0 ?
                                    <SortControl/>
                                    : <span></span>
                                }
                            </FlexboxGridItem>
                        </FlexboxGrid>
                    </FlexboxGridItem>
                </FlexboxGrid>
                :
                <FlexboxGrid justify="space-between" className={controlBarClass}>
                    <FlexboxGridItem className={styles.latestEntryItem}>
                        <LatestEntryInfo />
                    </FlexboxGridItem>

                    <FlexboxGridItem>
                        <FlexboxGrid justify="end" className={styles.controlsRow}>
                            <FlexboxGridItem>
                                <ViewSwitch/>
                            </FlexboxGridItem>

                            <FlexboxGridItem>
                                <DateNav width={props.width} mobile={props.mobile}/>
                            </FlexboxGridItem>

                            <FlexboxGridItem>
                                { viewType===0 ?
                                    <SortControl/>
                                    : <span></span>
                                }
                            </FlexboxGridItem>
                        </FlexboxGrid>
                    </FlexboxGridItem>
                </FlexboxGrid>
                }

                {mobile ?
                    <FlexboxGridItem className={styles.mobileLegend}>
                    {calRangeUsed == 3 ?
                        <FlexboxGrid className={styles.yearLegend_mobile}>
                            <div style={{fontSize:"0.8em"}}>Number of reports:</div>
                            <div className={styles.inner_container}>
                                <StyledDiv className={styles.stDiv1} color={"#d4d4d4"}/>
                                <div style={{marginLeft:"10px", fontSize:"0.8em"}}>more than 10</div>
                            </div>
                            <div className={styles.inner_container}>
                                <StyledDiv className={styles.stDiv2} color={"#e5e5e5"}/>
                                <div style={{marginLeft:"10px", fontSize:"0.8em"}}>between 5 and 10</div>
                            </div>
                            <div className={styles.inner_container}>
                                <StyledDiv className={styles.stDiv3} color={"#f2f2f2"}/>
                                <div style={{marginLeft:"10px", fontSize:"0.8em"}}>less than 5</div>
                            </div>

                        </FlexboxGrid>
                        :
                        null
                    }
                    </FlexboxGridItem>:
                    <FlexboxGridItem>
                    {calRangeUsed == 3 ?
                    <FlexboxGrid className={styles.yearLegend} justify="start" align="middle">
                        <div style={{fontSize:"0.8em"}}>Number of reports:</div><StyledDiv className={styles.stDiv1} color={"#d4d4d4"}/><div style={{fontSize:"0.8em"}}>more than 10</div>
                        <StyledDiv className={styles.stDiv2} color={"#e5e5e5"}/><div style={{fontSize:"0.8em"}}>between 5 and 10</div>
                        <StyledDiv className={styles.stDiv3} color={"#f2f2f2"}/><div style={{fontSize:"0.8em"}}>less than 5</div>
                    </FlexboxGrid>
                    :
                    null
                    }
                </FlexboxGridItem>
                }

            {/* Calendar grid — only this section dims during loading */}
            {(loading || !dataReady) && <InlineSpinner />}
            <div style={(loading || !dataReady) ? dimStyle : undefined}>
                {calRangeUsed === 3 ?
                <div className={styles.container}>
                    <div className={styles.inner_container}>
                        <div className={usedTitleLabel}>{calRangeValue}</div>
                    </div>
                    <div>
                        <YearViewComp width={props.width}/>
                    </div>
                    {/* <Calendar year={calRangeValue} displayHeader={false} ref={calendarYearRef} /> */}
                </div>
                :
                null
                }
                {calRangeUsed === 0 ?
                <div className={styles.container}>
                    <div className={styles.inner_container}>
                        <div className={usedTitleLabel}>{CONSTANTS.MONTHS.FULL[parseInt(calRangeValue.split("-")[1])]} {calRangeValue.split("-")[0]}</div>
                    </div>
                    <div>
                        <MonthViewComp width={props.width}/>
                    </div>
                </div>
                :
                null
                }
                {calRangeUsed === 1 ?
                    calRangeValue.split("-")[0] !== endDateStr.split("-")[0] ?
                    <div className={styles.container}>
                        <div className={styles.inner_container}>
                            <div className={usedTitleLabel}>
                                Week from {calRangeValue.split("-")[2]} {CONSTANTS.MONTHS[parseInt(calRangeValue.split("-")[1])]}
                                &nbsp;to {endDateStr.split('-')[2]} {CONSTANTS.MONTHS[parseInt(endDateStr.split('-')[1])]}
                                &nbsp;- {calRangeValue.split("-")[0]}/{endDateStr.split("-")[0]}
                            </div>
                        </div>
                        <WeekViewComp width={props.width}/>
                    </div>
                    :
                    <div className={styles.container}>
                        <div className={styles.inner_container}>
                            <div className={usedTitleLabel}>
                                Week from {calRangeValue.split("-")[2]} {CONSTANTS.MONTHS[parseInt(calRangeValue.split("-")[1])]}
                                &nbsp;to {endDateStr.split('-')[2]} {CONSTANTS.MONTHS[parseInt(endDateStr.split('-')[1])]}
                                &nbsp;- {calRangeValue.split("-")[0]}
                            </div>
                        </div>
                        <WeekViewComp />
                    </div>
                : null
                }
            </div>
        </div>
    );

}

export default CalendarComp;
